export default __webpack_public_path__ + "static/media/CafeKahshStoreWeb.da3f32ee.png";